import { PropsWithChildren } from 'react';
import clsx from 'clsx';
import styles from './MainContent.module.scss';

export default function MainContent({
  centerContent = false,
  children,
}: PropsWithChildren<{ centerContent?: boolean }>) {
  const mainContentStyle = clsx(
    styles.mainContent,
    centerContent && styles.mainContentCenter
  );
  return <main className={mainContentStyle}>{children}</main>;
}
